import { Box, useColorModeValue } from "@chakra-ui/react"
import { ReactNode } from "react"

interface AuthCardProps {
    children: ReactNode
}

const AuthCard = ({ children }: AuthCardProps) => {
    return (
        <Box
            rounded={'lg'}
            bg={useColorModeValue('white', 'gray.700')}
            boxShadow={'lg'}
            p={8}>
            {children}
        </Box>
    )
}

export default AuthCard
